<template>
    <ai-grid-edit-wrapper
        ref="gridRef"
        :args="args"
        :meta="meta"
        :editing="editing"
        :hasnt-route="true"
        :to-remove-toolbar-items-names="toRemoveToolbarItemsNames"
        :toolbar-user-items="toolbarUserItems"
        @grid-edit-wrapper-mounted="onGridEditWrapperMounted"
    >
        <template #detail="{ data }">
            <locked-users-grid :dataSource="data" />
        </template>
    </ai-grid-edit-wrapper>
</template>

<script setup>
import { ref, reactive, computed } from 'vue';
import AiGridEditWrapper from '@/components/wrappers/ai-grid-edit-wrapper.vue';
import LockedUsersGrid from '@/views/administration/locks/locked-users-grid.vue';
import { getLockReasons } from '@/service/admin-service.js';
import environmentStore from '@/store/enviroment-data.js';
import locksLocalStore from '@/views/administration/locks/store.js';

const { disableUiElement } = environmentStore;
const { UI_ELEMENTS_IDS } = locksLocalStore;

const lockReasons = ref();
const gridRef = ref();
const isEditing = !disableUiElement(UI_ELEMENTS_IDS.MASS_LOCKS_GRID);

const onGridEditWrapperMounted = async () => {
    changeDisableDeleteButton(true);
    if (isEditing) {
        gridRef.value.ref.gridRef.gridInstance.on('selectionChanged', onSelectionChanged);
    }
    lockReasons.value = await getLockReasons();
};

const changeDisableDeleteButton = (value) => {
    gridRef.value.ref.gridRef.setRefValue('isCustomDeleteButtonDisabled', value);
}

const onSelectionChanged = (e) => {
    if (e.selectedRowKeys.length) {
        changeDisableDeleteButton(false);
    } else {
        changeDisableDeleteButton(true);
    }
}

const args = reactive({
    select: {
        not_expired: true,
    },
});

const toRemoveToolbarItemsNames = ['copy', 'choice', 'edit', 'add', 'delete'];

const toolbarUserItems = [
    {
        widget: 'dx-button',
        index: 1,
        component: {
            name: 'delete',
            disabledRefName: 'isCustomDeleteButtonDisabled',
            hint: 'Удалить',
            emits: [{ name: 'click' }],
            htmlElement: 'ai-delete-base',
        },
    },
];

const meta = computed(() => ({
    keyExpr: 'group_id',
    title: 'Массовые блокировки',
    allowSelectAll: true,
    enableMasterDetail: true,
    viewId: 'mass-locks-view',
    api: {
        select: 'admin./user/lock-mass/get',
        save: 'admin./lock-mass-save/set',
    },
    rights: {
        INS: isEditing,
        UPD: isEditing,
        DEL: isEditing,
    },
    columns: [
        {
            caption: 'ID',
            dataField: 'group_id',
            dataType: 'string',
            allowEditing: false,
            visible: false,
        },
        {
            caption: 'Дата начала',
            dataField: 'dt_beg',
            dataType: 'datetime',
            allowEditing: isEditing,
            visible: true,
            calculateDisplayValue: (rowData) => {
                if (!rowData.dt_beg) return null;
                const date = new Date(rowData.dt_beg);
                return date.toLocaleString('ru-RU', {
                    day: 'numeric',
                    month: 'numeric',
                    year: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit',
                });
            },
        },
        {
            caption: 'Дата окончания',
            dataField: 'dt_end',
            dataType: 'datetime',
            allowEditing: isEditing,
            visible: true,
            validationRules: [{
                type: 'custom',
                validationCallback: (rowData) => {
                    if (!rowData.data.dt_beg || !rowData.data.dt_end) return true;
                    return new Date(rowData.data.dt_beg) < new Date(rowData.data.dt_end);
                },
                message: 'Дата окончания не может быть раньше даты начала',
            }],
            calculateDisplayValue: (rowData) => {
                if (!rowData.dt_end) return null;
                const date = new Date(rowData.dt_end);
                return date.toLocaleString('ru-RU', {
                    day: 'numeric',
                    month: 'numeric',
                    year: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit',
                });
            },
        },
        {
            name: 'pr_byt',
            caption: 'Тип',
            dataField: 'lock_type_id',
            allowEditing: isEditing,
            lookup: {
                dataSource: lockReasons.value,
                valueExpr: 'id',
                displayExpr: 'name',
            },
            visible: true,
        },
        {
            caption: 'Описание',
            dataField: 'reason',
            dataType: 'string',
            allowEditing: isEditing,
            visible: true,
        },
    ],
}));
</script>
